import React from 'react';
import DigitalCardLayerStyled from 'src/components/_common/DigitalCard/_components/DigitalCardLayer/index.styled';
import type { ComponentLayer } from 'src/components/_common/DigitalCard/_components/DigitalCardLayer/types';
import { useDigitalCardState } from 'src/components/_common/DigitalCard/_hooks/useDigitalCard';
import styled from 'styled-components';


/**
 * [디지털 카드 컴포넌트 레이어 컴포넌트]
 * 
 * @description
 * 디지털 카드의 컴포넌트 레이어를 렌더링하는 컴포넌트입니다.
 * 
 * @param {ComponentLayer} props - 컴포넌트 레이어 컴포넌트의 속성
 * ```ts
 * {
 *   idx: number; // 레이어의 고유 식별자
 *   name: string; // 레이어의 이름
 *   type: 'component'; // 레이어 타입
 *   zIndex: number; // 레이어의 z-index 값
 *   translateZ: number; // 레이어의 z축 변환 값
 *   borderRadius: number; // 레이어의 모서리 둥글기  
 *   component: (props: { isAllImagesLoaded?: boolean; isInteracting?: boolean }) => React.ReactNode; // 렌더링할 React 컴포넌트
 *   overflow?: 'visible' | 'hidden'; // 오버플로우 처리 방식 (컴포넌트 레이어만 적용 가능)
 * }
 * ```
 */
export const DigitalCardComponentLayer = ({ zIndex, translateZ, borderRadius, component, overflow }: ComponentLayer) => {
  const { isInteracting, isAllResourcesLoaded } = useDigitalCardState();

  return (
    <ComponentLayerWrapper
      $zIndex={zIndex}
      $translateZ={translateZ}
      $borderRadius={borderRadius}
      $overflow={overflow}
    >
      {component({ isAllResourcesLoaded, isInteracting })}
    </ComponentLayerWrapper>
  );
};

const ComponentLayerWrapper = styled(DigitalCardLayerStyled.BaseLayerWrapper)<{ $overflow?: 'visible' | 'hidden' }>`
  overflow: ${({ $overflow, $borderRadius }) =>
    $overflow === undefined && $borderRadius ? 'hidden' : $overflow};
  ${({ $borderRadius }) => ($borderRadius ? `border-radius: ${$borderRadius}px;` : '')}
`;
